// Pembungkus localStorage untuk kenyamanan per-peramban (bahasa, lipatan menu,
// sidebar yang diciutkan). Aksesnya bisa melempar galat — mode privat, data situs
// diblokir, atau kuota penuh — jadi semuanya ditelan dan pemanggil jatuh ke
// nilai bawaan. Jangan pakai untuk data yang harus bertahan atau dibaca server.

export function readStored(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key)
    return raw === null ? fallback : raw
  } catch {
    return fallback
  }
}

export function writeStored(key, value) {
  try {
    localStorage.setItem(key, value)
  } catch {
    /* abaikan: aplikasi tetap jalan tanpa penyimpanan */
  }
}

export function readStoredJson(key, fallback) {
  const raw = readStored(key)
  if (raw === null) return fallback
  try {
    return JSON.parse(raw)
  } catch {
    return fallback
  }
}

export function writeStoredJson(key, value) {
  writeStored(key, JSON.stringify(value))
}
